import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';

import { Button, ExpandableSection, FormField, Input, Popover, SpaceBetween, StatusIndicator, Table, TruncatedText } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiPrinterOutline } from '@mdi/js';
import Icon from '@mdi/react';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelMant from '../../../../../components/extras/SidePanelMant';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemEquipment, ItemNote } from '../../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';

interface EquipmentGroup {
  idCategory: number;
  category: string;
  equipments: ItemEquipment[];
}

export const CMAEquipmentsStatePage = () => {
  const { idUser, menu } = useGlobalState();
  const [equipments, setEquipments] = useState<ItemEquipment[]>([]);
  const [equipment, setEquipment] = useState<ItemEquipment>();
  const [note, setNote] = useState<ItemNote>();

  const [idEquipment, setIdEquipment] = useState<number>(0);
  const [filteringText, setFilteringText] = useState<string>("");


  const handleGetEquipments = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/equipments/list',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({
          columns: "idEquipment, registration, make, model, idCategory, category, isOutOfFlight, isMant, isActiveEquipment, isDeleteEquipment, jsonOwners, outOfFlightStart, outOfFlightEnd, obsCMA, jsonEquipmentSoftMantto, groupTypeMasterCode",
          isActiveEquipment: 1,
          isDeleteEquipment: 0,
          isMant: 1,
          orderBy: "registration",
          order: "ASC"
        })
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.equipments) {
        /*
        const filteredEquipments = data.equipments.filter((eq: { jsonOwners: any; }) => {
          const owners = Array.isArray(eq.jsonOwners) ? eq.jsonOwners : [];
          return owners.length === 0 || owners.includes(idUser);
        });
        */
        const filteredEquipments = data.equipments.filter((equipment: any) => {
          const hasOwners = (equipment.jsonOwners?.length || 0) > 0;
          const isGlider = equipment.groupTypeMasterCode === "GLIDER";

          // Keep if it's a Glider WITH owners, OR if it has NO owners regardless of type
          return (isGlider && hasOwners) || !hasOwners;
        });
        setEquipments(filteredEquipments);
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };


  const handleSyncSoftMantto = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/equipments/syncsm',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({
          columns: "idEquipment, registration, make, model, idCategory, category, isOutOfFlight, isMant, isActiveEquipment, isDeleteEquipment, jsonOwners, outOfFlightStart, outOfFlightEnd, obsCMA, jsonEquipmentSoftMantto",
          isActiveEquipment: 1,
          isDeleteEquipment: 0,
          isMant: 1,
          orderBy: "registration",
          order: "ASC"
        })
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data && data.code == 0) {
        if (data.equipments) {
          const filteredEquipments = data.equipments.filter((eq: { jsonOwners: any; }) => {
            const owners = Array.isArray(eq.jsonOwners) ? eq.jsonOwners : [];
            return owners.length === 0 || owners.includes(idUser);
          });
          setEquipments(filteredEquipments);

        }
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };


  const handleUpdateEquipment = async (eq: any) => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/equipments/update',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify(eq)
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data && data.code == 0) {
        handleGetEquipments();
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleRequestPDF = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/equipments/report',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({})
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'reports.equipment.pdf'; // File name matching your backend
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };



  const filteredEquipments = equipments.filter((e: ItemEquipment) => {
    const matchesMant = e.isMant === 1;
    const matchesSearch = filteringText
      ? e.registration.toLowerCase().includes(filteringText.toLowerCase()) ||
      e.model.toLowerCase().includes(filteringText.toLowerCase()) ||
      e.category.toLowerCase().includes(filteringText.toLowerCase()) ||
      e.make?.toLowerCase().includes(filteringText.toLowerCase())
      : true;

    return matchesMant && matchesSearch;
  });

  const mainGroupIds = new Set<number>(
    filteredEquipments
      .filter((e: ItemEquipment) => e.isMant === 1)
      .map((e: ItemEquipment) => e.idCategory)
  );

  const grouped: EquipmentGroup[] = Array.from(mainGroupIds).map((idCategory: number) => {
    const groupCategory = filteredEquipments.filter(
      (e: ItemEquipment) => e.idCategory === idCategory && e.isMant === 1
    );

    const { category } = groupCategory[0];

    return {
      idCategory,
      category,
      equipments: groupCategory
    };
  });

  useEffect(() => {
    handleGetEquipments()
  }, []);
  return (
    <CustomAppLayout

      toolsHide={true}
      splitPanelOpen={!!note}
      onSplitPanelToggle={({ detail }) => !detail.open ? setNote(undefined) : null}
      splitPanel={
        <SidePanelMant note={note ?? {}} />
      }
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <SpaceBetween size="s">
            <Header variant="h1" actions={<SpaceBetween direction="horizontal" size="xs"><Favorites /></SpaceBetween>}>Estado de Aeronaves</Header>
            <SpaceBetween size="l">
              {grouped.map((group, index) => (
                <ExpandableSection expanded headerText={group.category} headerActions={
                  index === 0 && (
                    <SpaceBetween direction="horizontal" size="xs">
                      <Button variant="primary" onClick={() => {
                        handleSyncSoftMantto();
                      }}>Sync SM</Button>
                      <Button style={{ root: btnIconForm }} onClick={() => {
                        handleRequestPDF();
                      }}>
                        <Icon path={mdiPrinterOutline} size={1} /></Button>
                    </SpaceBetween>
                  )
                }>
                  <Table
                    submitEdit={async (item, column, newValue) => {
                      console.log("submitEdit", "obsCMA", item.obsCMA, "newValue", newValue)
                      if (item.obsCMA === newValue) return;
                      handleUpdateEquipment({ idEquipment: item.idEquipment, obsCMA: newValue })
                    }}
                    columnDefinitions={[
                      {
                        id: "registration",
                        header: "Matrícula",
                        cell: (item) => item.registration,
                        width: 120,
                      },
                      {
                        id: "make",
                        header: "Fabricante",
                        cell: (item) => <FormField label={item.model}>{item.make}</FormField>,
                        width: 200,
                      },
                      {
                        id: "obsCMA",
                        header: "Observaciones",
                        cell: (item) => <TruncatedText>{item.obsCMA}</TruncatedText>,
                        editConfig: {
                          ariaLabel: "Name",
                          editIconAriaLabel: "editable",
                          errorIconAriaLabel: "Name Error",
                          editingCell: (
                            item,
                            { currentValue, setValue }
                          ) => {
                            return (
                              <Input
                                autoComplete="off"
                                autoFocus={true}
                                value={currentValue ?? item.obsCMA}
                                onChange={event => {
                                  setValue(event.detail.value)
                                }}
                              />
                            );
                          }
                        },
                        width: 300,
                      },
                      {
                        id: "state",
                        header: "Estado",
                        cell: (item) =>
                          item.outOfFlightStart === "" && item.outOfFlightStart === "" ?

                            <StatusIndicator type={item.isOutOfFlight === 1 ? "error" : "success"}>
                              {item.isOutOfFlight === 1 ? "Fuera de vuelo" : "En vuelo"}
                            </StatusIndicator>
                            :
                            <Popover header='Fecha FDV' content={
                              <SpaceBetween size="s">
                                {item.outOfFlightStart !== "" ? <div>Inicio: {item.outOfFlightStart}</div> : null}
                                {item.outOfFlightEnd !== "" ? <div>Término: {item.outOfFlightEnd}</div> : null}
                              </SpaceBetween>
                            } triggerType="custom">

                              <StatusIndicator type={item.isOutOfFlight === 1 ? "error" : "success"}>
                                {item.isOutOfFlight === 1 ? "Fuera de vuelo" : "En vuelo"}
                              </StatusIndicator>
                            </Popover>
                        ,
                        width: 160,
                      },
                      {
                        id: "hours",
                        header: "Horas",
                        cell: (item) => item?.jsonEquipmentSoftMantto?.medicionHr ?? 0,
                        width: 100,
                      },
                    ]}

                    items={group.equipments}
                  />

                </ExpandableSection>
              ))}
            </SpaceBetween>


          </SpaceBetween>
        </>
      }
    />
  );
};
